import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MGMT, LEAD, fmtD, today } from "@/lib/constants";
import { PageHeader } from "@/components/Common";
import { CrudPage } from "@/components/CrudPage";
import { StatusBadge, Badge } from "@/components/Badges";

const AUDIT_FIELDS = [
  { key: "hotel_id", label: "Struttura", type: "hotel", required: true },
  { key: "date", label: "Data", type: "date", required: true },
  { key: "type", label: "Tipo", type: "select", options: ["programmato", "a campione"], required: true },
  { key: "area", label: "Ambito verificato", type: "select", required: true, options: ["Controllo accessi e ronde", "Dotazioni e divise", "Procedure di emergenza", "Puntualità e continuità", "Comportamento personale", "Registri e reportistica"] },
  { key: "auditor", label: "Auditor", required: true },
  { key: "score", label: "Punteggio (0-100)", type: "number", required: true },
  { key: "outcome", label: "Esito", type: "select", options: ["conforme", "con osservazioni", "non conforme"], required: true },
  { key: "notes", label: "Note", type: "textarea" },
];
const AUDIT_COLS = [
  { key: "date", label: "Data", render: (r) => <span className="font-mono text-xs">{fmtD(r.date)}</span> },
  { key: "type", label: "Tipo" },
  { key: "area", label: "Ambito" },
  { key: "auditor", label: "Auditor" },
  { key: "score", label: "Punteggio", render: (r) => <span className={`font-heading font-bold ${r.score >= 90 ? "text-emerald-600" : r.score >= 75 ? "text-amber-600" : "text-red-600"}`}>{r.score}</span> },
  { key: "outcome", label: "Esito", render: (r) => <StatusBadge value={r.outcome} /> },
];

const NC_FIELDS = [
  { key: "hotel_id", label: "Struttura", type: "hotel", required: true },
  { key: "origin", label: "Origine", type: "select", options: ["Audit", "Supervisione", "Visita Coordinatore", "Segnalazione hotel", "Autocontrollo"], required: true },
  { key: "severity", label: "Gravità", type: "select", options: ["bassa", "media", "alta"], required: true },
  { key: "description", label: "Non conformità rilevata", type: "textarea", required: true },
  { key: "corrective_action", label: "Azione correttiva", type: "textarea", required: true },
  { key: "owner", label: "Responsabile", required: true },
  { key: "due_date", label: "Data obiettivo", type: "date", required: true },
  { key: "status", label: "Stato", type: "select", options: ["aperta", "in corso", "chiusa"], required: true },
];
const overdue = (r) => r.status !== "chiusa" && r.due_date < today();
const NC_COLS = [
  { key: "description", label: "Non conformità", render: (r) => <span className="block max-w-xs">{r.description}</span> },
  { key: "origin", label: "Origine" },
  { key: "severity", label: "Gravità", render: (r) => <StatusBadge value={r.severity} /> },
  { key: "corrective_action", label: "Azione correttiva", render: (r) => <span className="block max-w-xs text-slate-500">{r.corrective_action}</span> },
  { key: "owner", label: "Responsabile" },
  { key: "due_date", label: "Scadenza", render: (r) => overdue(r) ? <Badge tone="bad">{fmtD(r.due_date)} · scaduta</Badge> : <span className="font-mono text-xs">{fmtD(r.due_date)}</span> },
  { key: "status", label: "Stato", render: (r) => <StatusBadge value={r.status} /> },
];

export default function Qualita() {
  return (
    <>
      <PageHeader eyebrow="Quality & Compliance" title="Qualità" subtitle="Audit programmati e a campione, non conformità e azioni correttive con responsabile e data obiettivo." />
      <Tabs defaultValue="audit">
        <TabsList>
          <TabsTrigger value="audit" data-testid="tab-audits">Audit</TabsTrigger>
          <TabsTrigger value="nc" data-testid="tab-nc">Non conformità & Azioni correttive</TabsTrigger>
        </TabsList>
        <TabsContent value="audit" className="mt-4">
          <CrudPage resource="audits" title="Audit" testid="audits" fields={AUDIT_FIELDS} columns={AUDIT_COLS} writeRoles={MGMT} newLabel="Nuovo audit"
            defaults={() => ({ date: today(), type: "programmato", auditor: "Quality & Compliance Auditor" })} />
        </TabsContent>
        <TabsContent value="nc" className="mt-4">
          <CrudPage resource="nonconformities" title="Non conformità" testid="nc" fields={NC_FIELDS} columns={NC_COLS} writeRoles={LEAD} newLabel="Nuova NC"
            defaults={{ status: "aperta", severity: "media" }} rowClass={(r) => (overdue(r) ? "bg-red-50/70" : "")} />
        </TabsContent>
      </Tabs>
    </>
  );
}
